import { Email, Phone } from "@mui/icons-material";
import BusinessIcon from "@mui/icons-material/Business";
import { Box, Card, Grid, Link, styled, Typography } from "@mui/material";
import React, { useState } from "react";

import { primary } from "../../constants/theme";
import { MemoizedButton } from "../../SDK/button";
import { MemoizedNameField } from "../../SDK/input/nameInput";
import { MemoizedPhoneField } from "../../SDK/input/phoneInput";
import { checkError } from "../../SDK/utils/validationHelpers";
import { createCookieInHour } from "../../utils/cookie";
import useContactUs from "./hooks/useContactUs";

const CustomContactUs = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100vh",
  background: `linear-gradient(
      to top,
      ${primary.white} 0%,
      ${primary.white} 70%,
      ${primary.secondary} 30%,
      ${primary.secondary} 100%
    )`,
  display: "flex",
  textAlign: "center",
  justifyContent: "center",

  ".h1-text": { color: "white" },
  ".block-info": {
    marginTop: "10%",
    width: "70%",
    position: "absolute",
  },

  ".contact-us-info": {
    background: primary.lightYellowBg,
    padding: "5%",
    paddingTop: "8%",
    textAlign: "left",
  },

  ".form-info": {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",
    padding: "2em",
    paddingTop: "4em",
    width: "100% !important",
  },

  ".svg_icons_phone": {
    transform: "scale(1.5)",

    width: "12px",
    height: "12px",
    marginRight: "0.5em",
  },

  ".input-field": {
    minWidth: "100% !important",
  },

  [theme.breakpoints.down("sm")]: {
    background: primary.white,
    display: "block",
    ".h1-text": { display: "none" },

    ".block-info": {
      marginTop: "0%",
      width: "100%",
      position: "relative",
    },

    ".contact-us-info": {
      padding: "1em",
      paddingTop: "2em",
    },

    ".form-info": {
      padding: "1em",
      paddingTop: "2em",
    },

    ".input-field": {
      minWidth: "100% !important",
    },
  },
}));

const ContactUs = () => {
  const { form, loading } = useContactUs();
  const [isCheckedModal, setIsCheckedModal] = useState(true);

  return (
    <CustomContactUs>
      <div>
        <h1 className="h1-text">
          Contact Turno to book commercial electric auto
        </h1>
      </div>
      <Card className="block-info">
        <Grid container>
          <Grid
            container
            className="contact-us-info"
            xs={12}
            sm={5}
            item
            direction={"column"}
          >
            <Typography style={{ fontSize: "24px", fontWeight: 700 }}>
              Contact Turno
            </Typography>
            <Typography
              variant="p"
              sx={{ fontSize: "14px", paddingTop: "0px" }}
            >
              <h2
                style={{
                  fontSize: "14px",
                  paddingTop: "24px",
                  fontWeight: "400",
                  padding: "0px",
                }}
              >
                {"Get in touch with us"}
              </h2>
            </Typography>

            <Typography sx={{ paddingTop: "2em" }}>
              <Email
                className="svg_icons_phone"
                sx={{ verticalAlign: "center" }}
              />{" "}
              {"sales@turno.club"}
            </Typography>

            <Typography sx={{ paddingTop: "0.5em" }}>
              <Phone
                className="svg_icons_phone"
                sx={{ verticalAlign: "center" }}
              />{" "}
              {"08047482233"}
            </Typography>
            <Typography sx={{ paddingTop: "0.5em", fontSize: "16px" }}>
              <BusinessIcon
                className="svg_icons_phone"
                sx={{ verticalAlign: "center" }}
              />
              Industrial Plot Bearing No 7-A1, 3rd Cross Rd, Devasandra
              Industrial Estate, Krishnarajapura, Near VR mall, Bengaluru,
              Karnataka 560048
            </Typography>
          </Grid>

          <Grid className="form-info" xs={12} sm={7} item>
            <form onSubmit={form.handleSubmit}>
              <Typography sx={{ textAlign: "left" }}>
                <span style={{ color: "red" }}>*</span>
                Your Name
              </Typography>
              <MemoizedNameField
                className="input-field"
                name="name"
                error={!!checkError("name", form)}
                helperText={form.errors.name}
                placeholder="Your Name"
                value={form.values.name}
                onChange={(e) => {
                  form.handleChange(e);
                }}
              />

              <Typography sx={{ textAlign: "left", width: "100%", mt: "1em" }}>
                <span style={{ color: "red" }}>*</span>
                Phone number
              </Typography>
              <MemoizedPhoneField
                sx={{ minWidth: "100% !important" }}
                error={!!checkError("mobile", form)}
                helperText={form.errors.mobile}
                className="input-field"
                name="mobile"
                placeholder="Your Mobile"
                value={form.values.mobile}
                onChange={(e) => {
                  form.handleChange(e);
                }}
              />

              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mt: 2, textAlign: "left" }}>
                <input
                  type="checkbox"
                  style={{ width: "10px", marginTop: "4px" }}
                  required={true}
                  checked={isCheckedModal}
                  onChange={(e) => setIsCheckedModal(e.target.checked)}
                />
                <Typography className="check-label" sx={{ fontSize: "14px", lineHeight: 1.5 }}>
                  I agree to the{" "}
                  <Link
                    href="/terms-and-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: primary.main, textDecoration: "underline" }}
                  >
                    terms & conditions
                  </Link>
                  ,{" "}
                  <Link
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: primary.main, textDecoration: "underline" }}
                  >
                    privacy policy
                  </Link>{" "}
                  below and give my consent to receive calls, RCS and (WhatsApp) messages to provide further information, even if my number is registered on DND/NDNC.
                </Typography>
              </Box>

              <MemoizedButton
                id="lead-form"
                content={"Submit"}
                loading={loading}
                disabled={!isCheckedModal}
                handleClick={(e) => {
                  createCookieInHour("lead_trigger", "contact_us_form", 10);
                  form.handleSubmit(e);
                }}
                sx={{
                  width: "100%",
                  mt: "24px",
                  maxWidth: "500px",
                }}
              />
            </form>
          </Grid>
        </Grid>
      </Card>
    </CustomContactUs>
  );
};

export const MemoizedContactUs = React.memo(ContactUs);
